<template>
  <div class="hover:bg-gray-100">
    <a
      :title="item.name"
      class="block w-full cursor-pointer"
      @click="navigateToItemPage(item)"
    >
      <div class="grid grid-cols-3 gap-4 p-3">
        <div>
          <img
            v-if="item.image_url"
            :src="item.image_url"
            class="inline-block aspect-square max-h-44"
          />
        </div>
        <div class="col-span-2 py-2">
          <AisHighlight :hit="item" class="text-sm" attribute="name" />
          <ProductPrice v-if="item.price" :item="item" />
          <div v-if="item.products_count" class="text-sm">
            {{ item.products_count }}
            {{ $t('pages.category.products', item.products_count) }}
          </div>
        </div>
      </div>
    </a>
  </div>
</template>

<script setup lang="ts">
import { AlgoliaHit } from '@/types/Algolia/AlgoliaHit';
import ProductPrice from '@/components/Algolia/ProductPrice.vue';

export type AutocompleteHitProps = {
  item: AlgoliaHit;
};

defineProps<AutocompleteHitProps>();
const emit = defineEmits<{
  'on-item-click': [item: AlgoliaHit];
}>();

function navigateToItemPage(item: AlgoliaHit) {
  emit('on-item-click', item);
  location.href = `${window.BASE_URL}${item.url_key}`;
}
</script>
